import React from 'react';
import { connect } from 'react-redux';
import SportsList from './SportsList';
import Locations from './Locations';
import Prematch from '..';
import * as Maps from '../../../store/map';

function Sports(props) {
    let { isLocationsActive, isPrematchActive } = props.lSports.prematch;
    let drawLocations = isLocationsActive ? <Locations /> : null;
    let drawPrematch = isPrematchActive ? <Prematch /> : null;

    return (
        <div className="main-container">
            <SportsList />

            {drawLocations}
            {drawPrematch}
        </div>
    );
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(Sports);
